'use es6';

import PatagoniaAddWidget from 'InpageEditorUI/components/sidebar/add/PatagoniaAddWidget';
import InpageSidebarPortal from 'ContentEditorUI/components/portals/InpageSidebarPortal';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { addModuleToFlexColumnFromInpageSidebar } from 'InpageEditorUI/eventsAsActions/moduleEventsAsActions';
import AppWideKeyboardShortcutsContainer from 'ContentEditorUI/containers/AppWideKeyboardShortcutsContainer';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
import PatagoniaAddCategory from 'InpageEditorUI/components/sidebar/add/PatagoniaAddCategory';
import PatagoniaAddCategoryContainer from 'InpageEditorUI/components/sidebar/add/PatagoniaAddCategoryContainer';
import PatagoniaInpageAddSectionContainer from './sidebar/add/PatagoniaInpageAddSectionContainer';
import PatagoniaInpageLayoutsContainer from './sidebar/add/PatagoniaInpageLayoutsContainer';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { connect } from 'react-redux';
import { getIsTrellisTheme } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isTrellisTheme: getIsTrellisTheme(state)
});
class InpageSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.state = {
      sidebarIframeLoaded: false
    };
    const inpageIframeWindow = window;
    this.sidebarIframeWindow = inpageIframeWindow.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].window;
  }
  componentDidMount() {
    this.checkIfSidebarIframeIsLoaded();
  }
  checkIfSidebarIframeIsLoaded() {
    if (this.sidebarIframeWindow.document.readyState === 'complete') {
      this.onSidebarIframeLoaded();
    } else {
      this.sidebarIframeWindow.document.addEventListener('load', this.onSidebarIframeLoaded);
    }
  }
  onSidebarIframeLoaded() {
    const {
      onAddModuleSidebarLoadedAction
    } = this.props;
    onAddModuleSidebarLoadedAction();
    this.setState({
      sidebarIframeLoaded: true
    });
  }
  focusSearchInput() {
    const searchInput = this.sidebarIframeWindow.document.querySelector('.add-module-search input');
    if (searchInput) {
      searchInput.focus({
        preventScroll: true
      });
    }
  }
  onDragEnd(dropResult, dropItem) {
    const {
      bus,
      endDraggingFromInpageSidebar
    } = this.props;
    if (dropResult && dropResult.flexDropColumnId) {
      bus.dispatchActionToEventBus(addModuleToFlexColumnFromInpageSidebar({
        containerId: dropResult.flexDropColumnId,
        order: dropResult.dropIndex,
        type: dropItem.type,
        widgetCid: dropItem.widgetCid
      }));
    }
    endDraggingFromInpageSidebar(dropItem, !!dropResult);
  }
  onDragStart(dragPayload) {
    const {
      startDraggingFromInpageSidebar
    } = this.props;
    startDraggingFromInpageSidebar({
      dragPayload,
      fromInpageSidebar: true
    });
  }
  handleMouseDown() {
    const {
      iframeCaresAboutNextWindowClick,
      bus
    } = this.props;
    if (iframeCaresAboutNextWindowClick) {
      bus.postMessage({
        action: 'tellIframeSidebarClicked'
      });
    }
  }
  render() {
    const {
      sidebarIframeLoaded
    } = this.state;
    const {
      bus,
      onRedoAction,
      onUndoAction,
      categoryToModulesSchemasMap,
      sidebarSearchResultsMap,
      categoryToBuildingBlocksMap
    } = this.props;
    const {
      tour
    } = this.context;
    // Only try to portal render if the sidebar iframe is loaded
    if (!sidebarIframeLoaded) {
      return null;
    }
    return /*#__PURE__*/_jsx(InpageSidebarPortal, {
      sidebarIframeWindow: this.sidebarIframeWindow,
      isTrellisTheme: this.props.isTrellisTheme,
      children: /*#__PURE__*/_jsxs("div", {
        onMouseDown: this.handleMouseDown,
        children: [/*#__PURE__*/_jsxs(PatagoniaAddCategoryContainer, {
          children: [/*#__PURE__*/_jsx(PatagoniaAddCategory, {
            name: PATAGONIA_ADD_PANEL_CATEGORIES.MODULES,
            children: /*#__PURE__*/_jsx(PatagoniaAddWidget, {
              sidebarIframeWindow: this.sidebarIframeWindow,
              sidebarIframeBody: this.sidebarIframeWindow.document.body,
              bus: bus,
              onDragEnd: this.onDragEnd,
              onDragStart: this.onDragStart,
              shouldRenderTourStep: tour && tour.getStep() === 'dragImage',
              categoryToModulesSchemasMap: categoryToModulesSchemasMap,
              sidebarSearchResultsMap: sidebarSearchResultsMap,
              categoryToBuildingBlocksMap: categoryToBuildingBlocksMap
            })
          }), /*#__PURE__*/_jsx(PatagoniaAddCategory, {
            name: PATAGONIA_ADD_PANEL_CATEGORIES.SECTIONS,
            children: /*#__PURE__*/_jsx(PatagoniaInpageAddSectionContainer, {
              onDragEnd: this.onDragEnd,
              onDragStart: this.onDragStart,
              sidebarSearchResultsMap: sidebarSearchResultsMap
            })
          }), /*#__PURE__*/_jsx(PatagoniaAddCategory, {
            name: PATAGONIA_ADD_PANEL_CATEGORIES.LAYOUTS,
            children: /*#__PURE__*/_jsx(PatagoniaInpageLayoutsContainer, {
              onDragEnd: this.onDragEnd,
              onDragStart: this.onDragStart,
              sidebarSearchResultsMap: sidebarSearchResultsMap
            })
          })]
        }), /*#__PURE__*/_jsx(AppWideKeyboardShortcutsContainer, {
          windowToUse: this.sidebarIframeWindow,
          redoAction: onRedoAction,
          undoAction: onUndoAction
        })]
      })
    });
  }
}
InpageSidebarContainer.contextType = TourContext;
InpageSidebarContainer.propTypes = {
  bus: PropTypes.object.isRequired,
  iframeCaresAboutNextWindowClick: PropTypes.bool.isRequired,
  endDraggingFromInpageSidebar: PropTypes.func.isRequired,
  onRedoAction: PropTypes.func.isRequired,
  onUndoAction: PropTypes.func.isRequired,
  onAddModuleSidebarLoadedAction: PropTypes.func.isRequired,
  startDraggingFromInpageSidebar: PropTypes.func.isRequired,
  categoryToModulesSchemasMap: PropTypes.object.isRequired,
  categoryToBuildingBlocksMap: PropTypes.object.isRequired,
  sidebarSearchResultsMap: PropTypes.object,
  isTrellisTheme: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(InpageSidebarContainer);